import React, { lazy, Suspense } from 'react';
import type { DynamicMeshGradientProps } from './DynamicMeshGradient';
import styles from './DynamicMeshGradient.module.scss';
import { useThemeMode } from '@/contexts/ThemeModeContext';
import demoSnapshot from '@/data/demo-snapshot.json';
import { useIdleLoad } from '@/utils/useIdleLoad';

const DynamicMeshGradientInteractive = lazy(() => import('./DynamicMeshGradient').then(m => ({ default: m.DynamicMeshGradient })));

const GradientFallback: React.FC<DynamicMeshGradientProps> = (props) => {
  const { mode } = useThemeMode();
  const snapshotData = mode === 'dark' ? demoSnapshot.dark : demoSnapshot.light;
  const colors = [
    snapshotData.colorsByName.red?.[2]?.value || '#FF6038',
    snapshotData.colorsByName.orange?.[2]?.value || '#FFA411',
    snapshotData.colorsByName.blue?.[2]?.value || '#2E8CFF',
    snapshotData.colorsByName.gray?.[2]?.value || '#3C3A44',
  ];

  const fallbackStyle = {
    background: `linear-gradient(135deg, ${colors.join(', ')})`,
    opacity: 0.3,
    transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1)',
    ...props.style
  };

  return (
    <div 
      className={`${styles.dynamicMeshGradient} ${props.className || ''}`} 
      style={fallbackStyle}
      aria-hidden="true"
    />
  );
};

export const DynamicMeshGradientLazy: React.FC<DynamicMeshGradientProps> = (props) => {
  const ready = useIdleLoad(2000);

  if (!ready) {
    return <GradientFallback {...props} />;
  }

  return (
    <Suspense fallback={<GradientFallback {...props} />}>
      <DynamicMeshGradientInteractive {...props} />
    </Suspense>
  );
};
